import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { operatorList } from "../../constants/Operators";
import { circleList } from "../../constants/Circles";
import RechargeService from "../../services/RechargeService";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";
import DthInfoModal from "./DthInfoModal";
import BannerSlider from "./BannerSlider";
import PlanModal from "./PlansModal";
import storage from "../../utils/storage";
import RechargeTab from "../Wallet/RechargeTab";

const RecentTransactions = (props) => {
  return (
    <React.Fragment>
      <div className="card shadow-sm mb-4">
        <div className="card-body">
          <h5 className="card-title">Recharge History</h5>

          <RechargeTab hideLoading={true} />
        </div>
      </div>
    </React.Fragment>
  );
};

export default RecentTransactions;
